import React from "react";
import styled from "styled-components";

import logo from "./ar.svg";

const HeaderStyle = styled.header`
  top: 0;
  position: static;
  width: 100%;
  z-index: 9;
  color: white;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
  align-items: center;

  padding: 16px 0;

  img {
    height: 30px;
  }
`;

function Header({ locations, open, setOpen, updateLocation, user }) {
  return (
    <HeaderStyle>
      <img src={logo} alt="Assembly Row Logo" style={{ height: 40 }} />
    </HeaderStyle>
  );
}

export default Header;



// WEBPACK FOOTER //
// ./src/user/Header.js